import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getProjectDomainTableColumn,
  getTimeTableColumn,
  getTagTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
import { getExpiredAtColumn } from '../utils'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        formRules: [
          { required: true, message: i18n.t('system.text_168') },
        ],
        edit: row => row.idp_driver !== 'ldap',
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ row.name }</side-page-trigger>
          )
        },
      }),
      {
        field: 'displayname',
        title: i18n.t('scope.text_245'),
        slots: {
          default: ({ row }) => {
            return [<list-body-cell-wrap copy row={ row } field='displayname' title={ row.displayname || '-' } />]
          },
        },
      },
      getTagTableColumn({
        onManager: this.onManager,
        resource: 'users',
        needExt: true,
        columns: () => this.columns,
      }),
      getEnabledTableColumn(),
      getEnabledTableColumn({
        field: 'allow_web_console',
        title: i18n.t('system.text_512'),
      }),
      getEnabledTableColumn({
        field: 'enable_mfa',
        title: 'MFA',
      }),
      getExpiredAtColumn(),
      getProjectDomainTableColumn(),
      getTimeTableColumn(),
    ]
  },
}
